import styled from "styled-components";
import {colors} from "../../../themes/colors";
import {sizes} from "../../../themes/sizes";
import {fontSize} from "../../../themes/css";

const Subtitle = styled.div`
  width: 100%;
  font-style: normal;
  font-weight: 700;
  ${fontSize(17)}
  line-height: 140%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 8px;
  color: ${colors.text.chambray};
  @media only screen and ${sizes.max991} {
    margin-bottom: 2vh;
  }
`;

export default Subtitle;
